// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

/// <summary>
/// Буфер маркеров для серий индикаторов
/// </summary>
export let MarkersVector = function ()
{
    this.markers = new Object();//new Dictionary<int, Color>();
    this.counter = 0;
};

/// <summary>
/// Добавление пустого маркера в буфер
/// </summary>
MarkersVector.prototype.Add = function ()
{
    this.counter++;
};

/// <summary>
/// Очистка буфера
/// </summary>
MarkersVector.prototype.Clear = function ()
{
    this.markers = new Object();
    // подумать
    this.counter = 0;
};

MarkersVector.prototype.SetMarker = function (offset, color)
{
    this.markers[offset] = color;
};

MarkersVector.prototype.RemoveMarker = function (offset)
{
    return this.markers[offset] = null;
};

MarkersVector.prototype.ClearMarkers = function ()
{
    this.markers = new Object();
    // подумать
    this.counter = 0;
};

MarkersVector.prototype.getColor = function (index)
{
    let color = this.markers[index]
    if (color)
        return color;
    else
        return null;
};

Object.defineProperty(MarkersVector.prototype, "Count",
    {
        get: function () { return this.counter; }
    });

